import type { ISODateTimeString } from '@gat-ship/types'
import type { ResolvedCustomField } from './types'

export interface CustomFieldFormatters {
  formatDateTime: (v: ISODateTimeString) => string
  formatNumber: (v: number, opts?: { decimals?: number }) => string
}

export function formatCustomFieldValue(
  field: ResolvedCustomField,
  value: unknown,
  fmt: CustomFieldFormatters
): string {
  if (value === null || value === undefined || value === '') return '-'
  if (field.inputType === 'checkbox') return value ? 'Yes' : 'No'
  if (field.inputType === 'datetime' && typeof value === 'string') {
    return fmt.formatDateTime(value as ISODateTimeString)
  }
  if (field.inputType === 'number') {
    return fmt.formatNumber(value as number, {
      decimals: field.numberOfDecimals ?? undefined
    })
  }
  return String(value)
}
